import { render, staticRenderFns } from "./personalDistributionSetup.vue?vue&type=template&id=14c5e7cd&scoped=true"
import script from "./personalDistributionSetup.vue?vue&type=script&lang=js"
export * from "./personalDistributionSetup.vue?vue&type=script&lang=js"
import style0 from "./personalDistributionSetup.vue?vue&type=style&index=0&id=14c5e7cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c5e7cd",
  null
  
)

export default component.exports